import { useState } from "react";

import styles from "./Support.module.css";

import { usePageTitle } from "context/PageTitleContext";
import useGetSupportArticles from "hooks/useGetSupportArticles";
import SupportHeader from "components/Support/SupportHeader";
import SupportSearch from "components/Support/SupportSearch";
import SupportContact from "components/Support/SupportContact";
import KnowledgeArticle from "components/Support/KnowledgeArticle";

const Support = () => {
    usePageTitle("Support");
    const { supportArticles, error, isLoading } = useGetSupportArticles();

    const [searchText, setSearchText] = useState("");
    const normalizedSearchText = searchText.toLowerCase();
    const articles = supportArticles ?? [];

    const filteredArticles = articles.filter((article) =>
        article.title.toLowerCase().includes(normalizedSearchText),
    );

    const categories = [
        ...new Set(
            filteredArticles.map((article) => article.categoryTitles).flat(),
        ),
    ];

    return (
        <div className={styles.support}>
            <script
                id="Microsoft_Omnichannel_LCWidget"
                src="https://oc-cdn-public-gbr.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js"
                onerror="(function(el){el.parentNode.removeChild(el);var s=document.createElement('script');s.src='https://ocprodpublicgbrgs.blob.core.windows.net/livechatwidget/scripts/LiveChatBootstrapper.js';s.setAttribute('id', 'Microsoft_Omnichannel_LCWidget');s.setAttribute('data-app-id', 'fde84789-fabc-47b9-be48-28001145ca9a');s.setAttribute('data-lcw-version', 'prod');s.setAttribute('data-org-id', 'ae577d84-687b-48e5-a266-de3339d0875f');s.setAttribute('data-org-url', 'https://m-ae577d84-687b-48e5-a266-de3339d0875f.uk.omnichannelengagementhub.com');s.setAttribute('data-widget-ui-version', 'modern');document.body.appendChild(s);})(this);"
                data-app-id="fde84789-fabc-47b9-be48-28001145ca9a"
                data-lcw-version="prod"
                data-org-id="ae577d84-687b-48e5-a266-de3339d0875f"
                data-org-url="https://m-ae577d84-687b-48e5-a266-de3339d0875f.uk.omnichannelengagementhub.com"
                data-widget-ui-version="modern"
                async
            ></script>
            <SupportHeader categories={categories} />
            <SupportSearch
                searchText={searchText}
                setSearchText={setSearchText}
            />
            <SupportContact />
            {isLoading ? (
                <p>Loading support articles...</p>
            ) : error ? (
                <p>Error loading support articles: {error.message}</p>
            ) : (
                <div className={styles.articles} data-testid="support-articles">
                    {categories.map((category) => (
                        <div
                            key={category}
                            className={styles.supportCategory}
                            id={category}
                        >
                            <h1 className={styles.supportCategoryTitle}>
                                {category}
                            </h1>
                            {filteredArticles
                                .filter((article) =>
                                    article.categoryTitles.includes(category),
                                )
                                .map((article) => (
                                    <KnowledgeArticle
                                        key={article.id}
                                        title={article.title}
                                        content={article.content}
                                    />
                                ))}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Support;
